import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import ButtonToggle from '../../ButtonToggle/index'
import { getBoundActions } from '../../../actions/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { SPOTLIGHT_TOGGLED_GA4_EVENT } from '../../../services/event-tracking/index'

function componentFromHTML (html) {
  // eslint-disable-next-line react/no-danger
  return <p dangerouslySetInnerHTML={{ __html: html }} />
}
const MinimizeSpotlightSettings = (props) => {
  const { mhSpotlightCollapsed, staticText, setFeatureTrackingDataPersistent } = props

  const onMinimizeSpotlightSettingsChange = () => {
    setFeatureTrackingDataPersistent({
      data: Map({ mhSpotlightCollapsed: !mhSpotlightCollapsed }),
    })
  }

  // GA4 events
  const toggleEventData = SPOTLIGHT_TOGGLED_GA4_EVENT.mergeDeep({
    changed_to: mhSpotlightCollapsed ? 'on' : 'off',
    ui_location: 'Settings',
  })

  return (
    <div className="my-account-settings-V2__display-settings-controls">
      <div className="my-account-settings-V2__display-settings-text-container">
        <div className="my-account-settings-V2__display-settings-title">
          { staticText.getIn(['data', 'homepagePromotions']) }
        </div>
        <div className="my-account-settings-V2__display-settings-text">
          {componentFromHTML(staticText.getIn(['data', 'homepagePromotionsDesc']))}
        </div>
      </div>
      <div className="my-account-settings-V2__display-settings-toggle">
        <ButtonToggle
          checked={!mhSpotlightCollapsed}
          onChange={onMinimizeSpotlightSettingsChange}
          showLabel
          ga4EventData={toggleEventData}
          round
        />
      </div>
    </div>
  )
}

MinimizeSpotlightSettings.propTypes = {
  mhSpotlightCollapsed: PropTypes.bool,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
}

export default compose(
  connectRedux(
    (state) => {
      return {
        mhSpotlightCollapsed: state.featureTracking.getIn(['data', 'mhSpotlightCollapsed'], false),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
      }
    },
  ),
  connectStaticText({ storeKey: 'myAccountSettingsV2' }),
)(MinimizeSpotlightSettings)
